
import "./YouTubeFrame.css";

const extractYouTubeId = (url) => {
  if (!url) return null;

  try {
    const parsedUrl = new URL(url);

    // youtube.com/watch?v=VIDEO_ID
    if (parsedUrl.hostname.includes("youtube.com")) {
      const videoId = parsedUrl.searchParams.get("v");

      if (videoId) return videoId;

      // youtube.com/shorts/VIDEO_ID
      const shortsMatch = parsedUrl.pathname.match(
        /\/shorts\/([^/]+)/
      );

      if (shortsMatch) {
        return shortsMatch[1];
      }

      // youtube.com/embed/VIDEO_ID
      const embedMatch = parsedUrl.pathname.match(
        /\/embed\/([^/]+)/
      );

      if (embedMatch) {
        return embedMatch[1];
      }
    }

    // youtu.be/VIDEO_ID
    if (parsedUrl.hostname === "youtu.be") {
      return parsedUrl.pathname.substring(1);
    }

    return null;
  } catch (error) {
    return null;
  }
};

const YouTubeFrame = ({
  url,
  title = "Featured Video",
  description = "",
  category = "VIDEO",
  showInfo = true,
  showWatchButton = true,
  autoplay = false,
}) => {
  const videoId = extractYouTubeId(url);

  if (!videoId) {
    return (
      <div className="youtube-error">
        <span>⚠️</span>
        <p>Invalid YouTube URL</p>
      </div>
    );
  }

  const embedUrl =
    `https://www.youtube-nocookie.com/embed/${videoId}` +
    `?rel=0` +
    `&playsinline=1` +
    (autoplay ? "&autoplay=1" : "");

  return (
    <section className="youtube-section">
      <div className="youtube-card">

        {/* Decorative glow */}
        <div className="youtube-glow youtube-glow-one"></div>
        <div className="youtube-glow youtube-glow-two"></div>

        {/* Video */}
        <div className="youtube-video-wrapper">

          <iframe
            src={embedUrl}
            title={title}
            className="youtube-frame"
            loading="lazy"
            allow="
              accelerometer;
              autoplay;
              clipboard-write;
              encrypted-media;
              gyroscope;
              picture-in-picture;
              web-share
            "
            allowFullScreen
          />

          {/* Category */}
          <div className="youtube-badge">
            <span className="youtube-live-dot"></span>
            {category}
          </div>

        </div>

        {/* Information */}
        {showInfo && (
          <div className="youtube-content">

            <div className="youtube-heading">

              <div>
                <span  style={{ color: "black" }} className="youtube-small-label">
                  WATCH NOW
                </span>

                <h2  style={{ color: "black" }}>{title}</h2>
              </div>

              <div className="youtube-icon">
                ▶
              </div>

            </div>

            {description && (
              <p  style={{ color: "black" }} className="youtube-description">
                {description}
              </p>
            )}

            {showWatchButton && (
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="youtube-button"
                style={{ color: "black" }}
              >
                <span className="youtube-button-icon">
                  ▶
                </span>

                Watch on YouTube

                <span className="youtube-arrow">
                  →
                </span>
              </a>
            )}

          </div>
        )}

      </div>
    </section>
  );
};

export default YouTubeFrame;